/** Story chapters and the cross-map quests that tie the town, Taipei and Hualien together. */
export const enStory = {
  story: {
    ui: {
      chapter: (n: number) => `Chapter ${n}`,
      locked: 'Not available today',
      progress: (done: number, total: number) => `${done}/${total}`,
      offers: 'has something for you',
      talk: 'Talk to',
    },
    items: {
      postcard: { name: 'Taipei postcard', desc: 'For Grandma Lee. Three different ones make a set.' },
      pineappleCake: { name: 'Pineapple cakes', desc: 'A box of 鳳梨酥 from Taipei, for Mom.' },
      mochi: { name: 'Hualien mochi', desc: 'A box of soft 麻糬 for Bo. Eat them today!' },
      pebble: { name: 'Qixingtan pebble', desc: 'Round and grey, polished by the Pacific. For Rain.' },
      photo: { name: 'Photo from Elephant Mountain', desc: 'You and Taipei 101. For Emma.' },
    },
    chapters: {
      school: { title: 'First day back', hint: 'Friday at school: friends, teachers and a janitor who skipped breakfast.' },
      town: { title: 'Weekend in the neighbourhood', hint: 'Saturday and Sunday around town: lost kittens, kites and lucky clovers.' },
      taipei: { title: 'Postcards from Taipei', hint: 'Take the train from the station. The city has errands for you in every district.' },
      hualien: { title: 'Wind off the Pacific', hint: 'The train east goes to Hualien: marble gorges, pebble beaches and sticky mochi.' },
    },
    quests: {
      postcards: {
        offer: 'When I was young I never got to see the big city. Could you send me postcards from Taipei? One from the station, one from Longshan Temple and one from Liberty Square.',
        accept: 'I’ll collect three postcards for you!',
        collect: {
          guide: 'A postcard of Taipei Main Station — the big red-brick hall from 1941. Look, it’s even got the clock.',
          xm_volunteer: 'A postcard of Longshan Temple. Did you know it was built in 1738 by settlers from Fujian?',
          ck_guide: 'A postcard of the white gate of Liberty Square. Its five arches are 30 metres tall!',
        },
        ask: 'Could I have a postcard for my grandma?',
        give: 'Give Grandma the three postcards',
        thanks: 'Oh my… the station, the temple, the great gate! I feel like I’ve travelled with you. Thank you, dear.',
      },
      pineapple: {
        offer: 'Grandma is coming for tea and she loves pineapple cakes 鳳梨酥. The best ones are in Taipei — could you bring a box back if you go?',
        accept: 'I’ll bring a box of pineapple cakes!',
        buy: 'Buy a box of pineapple cakes (60🪙)',
        bought: 'Fresh from the oven! Buttery crust, pineapple jam inside. Keep the box flat.',
        poor: 'A box is 60 coins. Come back when you have enough!',
        give: 'Give Mom the pineapple cakes',
        thanks: 'Real Taipei pineapple cakes! Grandma will be so happy. You’re a star.',
      },
      elephant: {
        offer: 'Everybody at school has a photo of Taipei 101 from Elephant Mountain. Can you take one for me? Pleeease!',
        accept: 'I’ll climb up and take the photo!',
        ask: 'Could you take a photo of me with Taipei 101?',
        shot: 'Say cheese! …Perfect: the whole skyline behind you. 600 steps well spent.',
        give: 'Show Emma the photo from Elephant Mountain',
        thanks: 'WOW! The whole city! I’m putting it on the fridge. You’re the best!',
      },
      mochi: {
        offer: 'My cousin says Hualien mochi 麻糬 is the softest thing on Earth. If you ever go there… bring me some? I’ll trade you my best marble.',
        accept: 'Deal. Hualien mochi, coming up!',
        buy: 'Buy a box of mochi for Bo (40🪙)',
        bought: 'Pounded this morning — mung bean, sesame and peanut. Eat them today, they don’t keep!',
        poor: 'A box is 40 coins, young one. Save up and come back!',
        give: 'Give Bo the Hualien mochi',
        thanks: 'They’re so SOFT! Here, the marble — it’s yours. Best trade ever.',
      },
      pebble: {
        offer: 'I collect stones from all over Taiwan. The one I’m missing is a round grey pebble from Qixingtan beach in Hualien. Could you find one?',
        accept: 'A Qixingtan pebble. I’ll find one!',
        ask: 'Could I take one pebble for a friend’s collection?',
        found: 'One pebble? Fine — but only one, and tell your friend the beach needs the rest. The sea polished it for a thousand years.',
        give: 'Give Rain the Qixingtan pebble',
        thanks: 'Round, grey, smooth as glass… it’s perfect. Qixingtan, done! Thank you!',
      },
    },
  },
};
